import React from 'react';

import { styled } from '@mui/material/styles';
import classnames from 'classnames';

import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Card } from '../components/Card';
import Icon from '../components/Icon';
import { Color } from '../../theme';


const Container = styled('section')`
  padding-bottom: 0;

  .cards {
    margin-top: 20px;
    display: flex;
    justify-content: space-evenly;
    gap: 12px;

    .Card {
      flex: unset;
    }
  }

  .location-feature {
    margin-bottom: 5px;

    &.flex {
      display: flex;
      gap: 8px;
      align-items: center;
    }

    a {
      color: unset;

      :hover {
        color: ${Color.red};
        border-bottom: unset;
      }
    }
  }

  @media only screen and (max-width: 767px) {
  }
`;

const StyledIcon = styled(Icon)`
  color: ${Color.red};
  display: block;
`;

type Props = {
  className?: string;
};

const Locations = ({ className }: Props) => (
  <Container className={classnames('Locations', className)} id='contact'>
    <div className='row'>
      <h2>Contact Us</h2>
    </div>
    <div className='row'>
      <div className='cards'>
        <Card
          header={<h3>Physical Location</h3>}
          content={
            <>
              <div className='location-feature'>3470 Mt Pisgah Cemetery Rd</div>
              <div className='location-feature'>Conway, SC 29526</div>
              <div className='location-feature'>{`(843) 394-3545`}</div>
              <div className='location-feature flex'>
                <StyledIcon icon={faEnvelope} />
                <a href="mailto:accounting@coastalreadymixllc.com">accounting@coastalreadymixllc.com</a>
              </div>
            </>
          }
        />
        <Card
          header={<h3>Mailing Address</h3>}
          content={
            <>
              <div className='location-feature'>PO Box 159</div>
              <div className='location-feature'>Lake City, SC 29560</div>
            </>
          }
        />
      </div>
    </div>
  </Container>
);

export default Locations;

